import { gql } from '@apollo/client';

const GET_MAXIMUM_INSTANCE = gql`
  query GetMaximumInstance($orgId: Int) {
    maximumInstance(orgId: $orgId)
  }
`;

export default GET_MAXIMUM_INSTANCE;
